import { SiteOperator } from '@/common/model/siteOperator'

export const SiteOperatorApiPath = {
  LIST_SITE_OPERATORS: '/api/sites/{site_id}/operators', // GET List Site Operators
  CREATE_SITE_OPERATOR: '/api/sites/{site_id}/operators', // POST Create Site Operator
  UPDATE_SITE_OPERATOR: '/api/sites/{site_id}/operators/{operator_id}', // PUT Update Site Operator
  DELETE_SITE_OPERATOR: '/api/sites/{site_id}/operators/{operator_id}', // DELETE Delete Site Operator
  ASSIGN_PERMISSION_TEMPLATE: '/api/sites/{site_id}/operators/{operator_id}/template' // PUT Assign Permission Template
}

export type SiteOperatorApiPath = (typeof SiteOperatorApiPath)[keyof typeof SiteOperatorApiPath]

export interface ListSiteOperatorsVars {
  site_id: number
}

export interface CreateSiteOperatorVars {
  site_id: number
  email: string // ログインID（サイト内一意）
  password: string
  name: string
  permission_template_id?: number | null
}

export interface UpdateSiteOperatorVars {
  site_id: number
  operator_id: number
  name?: string | null
  email?: string | null
  password?: string | null // 未指定なら変更しない
  permission_template_id?: number | null
}

export interface DeleteSiteOperatorVars {
  site_id: number
  operator_id: number
}

export interface AssignPermissionTemplateVars {
  site_id: number
  operator_id: number
  template_id: number
}

export type ListSiteOperatorsResponse = SiteOperator[]
export type CreateSiteOperatorResponse = SiteOperator
export type UpdateSiteOperatorResponse = SiteOperator

export interface DeleteSiteOperatorResponse {
  ok: boolean
}

export interface AssignPermissionTemplateResponse {
  ok: boolean
}
